import {keyframes, styled} from "@mui/material/styles";
import {FC} from "react";

export type LoaderProps = {
    size?: number | string;
}

const drawPath = keyframes` 
    0% { stroke-dasharray: 168 0 0 0 212; } 
    10% { stroke-dasharray: 158 10 0 70 142; }
    50% { stroke-dasharray: 0 168 0 212 0; }
    60% { stroke-dasharray: 0 98 80 202 0; }
    100% { stroke-dasharray: 0 0 380 0 0; }
`;


const SvgContainer = styled('svg')<LoaderProps>(({ size = '150px', theme }) => ({
    width: size,
    height: size,
    '& .main-path': {
        stroke: theme.palette.primary.main,
        animation: `${drawPath} 2s linear infinite`,
    },
    '& .shadow-path': {
        stroke: theme.palette.primary.main,
        opacity: 0.2,
    },
}));

const Loader: FC<LoaderProps> = ({...props}) => {
    return (
        <SvgContainer viewBox="0 0 100 100" {...props}>
            <mask id="mask">
                <path d="m31.881 47.493c-3.6096-1.8295-8.0262-3.3836-12.525-3.3031-6.7158 0.12016-17.383 5.0371-16.79 15.901 0.62437 11.447 9.0866 17.087 16.889 17.087 7.8026 0 17.185-3.6544 30.618-15.408 13.432-11.753 20.741-21.334 20.741-30.321 0-8.0001-6.5186-9.8767-9.1853-9.8767s-6.2223-0.2963-11.753 6.9137c-5.2346-6.9137-8.5927-6.8149-11.062-6.8149-4.1482 0-10.371 3.0618-10.272 9.9755 0.12557 8.7899 7.3088 17.877 19.26 28.544 11.951 10.667 23.902 16.988 32.988 17.087 9.0866 0.09876 16.593-6.8149 16.494-16.494-0.09876-9.6792-6.5172-16.368-14.42-16.494-6.0802-0.09719-11.559 1.7841-15.697 3.786" fill="none" stroke="white" stroke-width="3"/>
                <path d="m45.94 65.236c11.572-9.2629 24.874-22.39 24.874-33.787" fill="none" stroke="black" stroke-width="10"/>
                <path d="m45.94 65.236c11.572-9.2629 24.874-22.39 24.874-33.787" fill="none" stroke="white" stroke-width="3"/>
                <path d="m28.542 31.646c0.11599 8.1195 6.2541 16.493 16.61 26.13" fill="none" stroke="black" stroke-width="10"/>
                <path d="m28.542 31.646c0.11599 8.1195 6.2541 16.493 16.61 26.13" fill="none" stroke="white" stroke-width="3"/>
            </mask>

            <path
                d="m31.881 47.493c-3.6096-1.8295-8.0262-3.3836-12.525-3.3031-6.7158 0.12016-17.383 5.0371-16.79 15.901 0.62437 11.447 9.0866 17.087 16.889 17.087 7.8026 0 17.185-3.6544 30.618-15.408 13.432-11.753 20.741-21.334 20.741-30.321 0-8.0001-6.5186-9.8767-9.1853-9.8767s-6.2223-0.2963-11.753 6.9137c-5.2346-6.9137-8.5927-6.8149-11.062-6.8149-4.1482 0-10.371 3.0618-10.272 9.9755 0.12557 8.7899 7.3088 17.877 19.26 28.544 11.951 10.667 23.902 16.988 32.988 17.087 9.0866 0.09876 16.593-6.8149 16.494-16.494-0.09876-9.6792-6.5172-16.368-14.42-16.494-6.0802-0.09719-11.559 1.7841-15.697 3.786"
                className="main-path"
                fill="none"
                stroke-width="3"
                mask="url(#mask)"
            />
            <path
                d="m31.881 47.493c-3.6096-1.8295-8.0262-3.3836-12.525-3.3031-6.7158 0.12016-17.383 5.0371-16.79 15.901 0.62437 11.447 9.0866 17.087 16.889 17.087 7.8026 0 17.185-3.6544 30.618-15.408 13.432-11.753 20.741-21.334 20.741-30.321 0-8.0001-6.5186-9.8767-9.1853-9.8767s-6.2223-0.2963-11.753 6.9137c-5.2346-6.9137-8.5927-6.8149-11.062-6.8149-4.1482 0-10.371 3.0618-10.272 9.9755 0.12557 8.7899 7.3088 17.877 19.26 28.544 11.951 10.667 23.902 16.988 32.988 17.087 9.0866 0.09876 16.593-6.8149 16.494-16.494-0.09876-9.6792-6.5172-16.368-14.42-16.494-6.0802-0.09719-11.559 1.7841-15.697 3.786"
                className="shadow-path"
                fill="none"
                stroke-width="3"
                mask="url(#mask)"
            />
        </SvgContainer>
    );
};

export default Loader;
